import Toast from 'react-native-toast-message';

import type { ToastDefaultProps } from '../molecules/toast';

type ShowToastOptions = Omit<Partial<ToastDefaultProps>, 'onClose'> & {
  message: string;
  visibilityTime?: number;
  autoHide?: boolean;
};

export function useToastMessage() {
  const showToast = ({
    message,
    type = 'success',
    visibilityTime = 5000,
    autoHide = true,
    buttonLabel,
    onPressButton,
    containerStyle,
  }: ShowToastOptions) => {
    Toast.show({
      type,
      visibilityTime,
      autoHide,
      props: {
        message,
        type,
        onClose: Toast.hide,
        buttonLabel,
        onPressButton,
        containerStyle,
      },
    });
  };
  const hideToast = () => {
    Toast.hide();
  };

  return { showToast, hideToast };
}
